// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"6edd575c","511":"721f40c4"}[chunkId] + ".chunk.js";
};